import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { format, parse } from 'date-fns';
import { IntlService } from '../../core/services/intl.service';
import { NgIf, NgFor, DatePipe } from '@angular/common';
import { DateFixPipe } from '../../shared-with-client/pipes/date-fix.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-client-time',
    templateUrl: './client-time.component.html',
    styleUrls: ['./client-time.component.scss'],
    imports: [
        NgIf,
        NgFor,
        DatePipe,
        DateFixPipe,
        TranslatePipe
    ],
    standalone: true
})
export class ClientTimeComponent implements OnInit {

  @Input() day;
  @Output() saved = new EventEmitter;
  language: any;

  constructor(private intlService: IntlService) { }

  ngOnInit() {
  }

  formatTime(time) {
    return format(parse(time, 'HH:mm', new Date()), this.intlService.getTimeFormat());
  }

  selectHour(hour) {
    this.saved.emit(hour);
  }

  hourToString(time = '08:00')  {
    time = time.replace(':', '');
    const hour = parseInt(time, 10);

    if (hour <= 1330) {
      return 'morning';
    }
    if (hour <= 1900) {
      return 'afternoon';
    }

    return 'night';
  }

  hoursExistsInPeriod(hours, period)  {

    let exists = false;
    for (const key in hours) {
      if (hours.hasOwnProperty(key)) {
        let time = hours[key];
        time = time.start.replace(':', '');
        const hour = parseInt(time, 10);

        if (hour <= 1330 && period === 'morning') {
          exists = true;
          break;
        } else if (hour > 1330 && hour <= 1900 && period === 'afternoon') {
          exists = true;
          break;
        } else if (hour > 1900 && hour <= 2400 && period === 'night') {
          exists = true;
          break;
        } else {
          exists = false;
        }

      }
    }
    return exists;
  }

}
